<template>
  <div class="home">
    <div class="categorys">
      <ul>
        <li :class="{ active: activeCategory === 'All' }" @click="setActiveCategory('All')">Alle</li>
        <li
          v-for="category in categorys"
          :key="category"
          :class="{ active: activeCategory === category }"
          @click="setActiveCategory(category)"
        >
          {{ category }}
        </li>
      </ul>
    </div>

    <div class="pictures">
      <div class="photo-grid-container">
        <div class="photo-grid">
          <div v-if="filteredImages.length === 0">Keine Bilder verfügbar.</div>

          <div
            v-for="image in filteredImages"
            :key="image.id"
            class="photo-item"
            @click="openModal(image)"
            @contextmenu.prevent
          >
            <img
              class="photo-thumb"
              :src="`/uploads/${image.filename}`"
              :alt="image.description"
              loading="lazy"
              draggable="false"
              @contextmenu.prevent
            >
            <div class="image-overlay">
              <p>{{ image.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isModalOpen" class="modal" @click="closeModal" @contextmenu.prevent>
      <div class="modal-content" @click.stop @contextmenu.prevent>
        <span class="close" @click="closeModal">&times;</span>
        <div class="modal-image-wrapper">
          <img
            class="modal-image"
            :src="`/uploads/${selectedImage.filename}`"
            :alt="selectedImage.description"
            draggable="false"
            @contextmenu.prevent
          >
        </div>
        <p class="modal-description">{{ selectedImage.description }}</p>
        <p class="modal-id">Foto Nummer: {{ selectedImage.id }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeCategory: 'All',
      images: [],
      categorys: ['Landschaft', 'Gebäude', 'Blumen', 'Berge', 'Tiere', 'Menschen', 'Pilze'],
      isModalOpen: false,
      selectedImage: {}
    }
  },
  computed: {
    filteredImages() {
      if (this.activeCategory === 'All') {
        return this.images
      }
      return this.images.filter(image => image.category === this.activeCategory)
    }
  },
  methods: {
    async fetchImages() {
      try {
        const response = await fetch('/api/images.php')
        this.images = await response.json()
      } catch (error) {
        console.error('Fehler beim Laden der Bilder:', error)
      }
    },
    setActiveCategory(category) {
      this.activeCategory = category
    },
    openModal(image) {
      this.selectedImage = image
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
      this.selectedImage = {}
    }
  },
  mounted() {
    this.fetchImages()
  }
}
</script>

<style scoped>
.home {
  background-color: black;
  color: white;
  min-height: 40vh;
}

.categorys {
  display: flex;
  justify-content: center;
  padding: 75px 0;
}

.categorys ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0;
  margin: 0;
  width: 140vh;
}

.categorys ul li {
  list-style: none;
  flex: 1 1 100px;
  text-align: center;
  padding: 10px 15px;
  cursor: pointer;
  transition: border 0.3s ease, color 0.3s ease;
  margin: 5px;
  text-transform: uppercase;
  border: 1px solid transparent;
}

.categorys ul li:hover {
  color: #aaa;
}

.categorys ul li.active {
  border-color: white;
}

.pictures {
  color: white;
  min-height: 22vh;
  padding-bottom: 20vh;
}

.photo-grid-container {
  display: flex;
  justify-content: center;
}

/* Masonry mit echten Seitenverhältnissen */
.photo-grid {
  column-count: 4;
  column-gap: 15px;
  width: 100%;
  max-width: 1600px;
}

.photo-item {
  display: inline-block;
  width: 100%;
  margin-bottom: 15px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  break-inside: avoid;
  border-radius: 0;
}

.photo-thumb {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease, filter 0.3s ease;
  -webkit-user-drag: none;
  user-select: none;
}

.photo-item:hover .photo-thumb {
  transform: scale(1.03);
  filter: brightness(0.8);
}

.image-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.photo-item:hover .image-overlay {
  opacity: 1;
}

/* Modal */
.modal {
  display: flex;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.modal-content {
  position: relative;
  background-color: transparent;
  border-radius: 0;
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  padding: 0 0 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-image-wrapper {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
}

.modal-image {
  max-width: 100%;
  max-height: 85vh;
  width: auto;
  height: auto;
  display: block;
  -webkit-user-drag: none;
  user-select: none;
}

.modal-description {
  color: white;
  margin-top: 10px;
  text-align: center;
}

.modal-id {
  color: white;
  margin-top: 5px;
  text-align: center;
}

.close {
  position: absolute;
  top: 8px;
  right: 12px;
  color: #ccc;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: white;
}

/* Responsive: Spaltenzahl runterfahren */
@media (max-width: 1200px) {
  .photo-grid {
    column-count: 3;
  }
}

@media (max-width: 900px) {
  .categorys {
    padding: 40px 0;
  }

  .categorys ul {
    width: 100%;
    padding: 0 10px;
  }

  .photo-grid-container {
    padding: 0 10px;
  }

  .photo-grid {
    column-count: 2;
  }

  .modal-content {
    max-width: 100vw;
    max-height: 100vh;
    padding: 0 0 20px;
  }

  .modal-image {
    max-height: 75vh;
  }
}

@media (max-width: 600px) {
  .photo-grid {
    column-count: 1;
  }
}
</style>
